import * as React from "react";
import { forwardRef } from "react";
const SvgDeleteIconSmall = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M15 9.75V17.25H9V9.75H15ZM13.875 5.25H10.125L9.375 6H6.75V7.5H17.25V6H14.625L13.875 5.25ZM16.5 8.25H7.5V17.25C7.5 18.075 8.175 18.75 9 18.75H15C15.825 18.75 16.5 18.075 16.5 17.25V8.25Z", fill: "#89A6FF" }), /* @__PURE__ */ React.createElement("rect", { opacity: 0.2, width: 24, height: 24, rx: 4, fill: "#546A8C" }));
const ForwardRef = forwardRef(SvgDeleteIconSmall);
export { ForwardRef as ReactComponent };
